export const enum Routes {
  base = "/",

  // demo
  demos = "/demos",

  //auth
  auth = "/auth",
  login = "/auth/login",
  createAccount = "/auth/create-account",
  forgotPassword = "/auth/forgot-password",
  resetPassword = "/auth/reset-password/:token",
  verifyEmail = "/auth/verify-email",
  acceptInvite = "/auth/invite/:token",
  authorizeEmail = "/authorize-email/:token",
  mfaSetup = "/auth/mfa/setup",

  // onboarding
  onboarding = "/onboarding",
  getStarted = "/onboarding/get-started",
  getStartedUpload = "/onboarding/get-started/upload",
  getStartedAboutBusiness = "/onboarding/get-started/about-business",
  businessInfo = "/onboarding/business-info",
  /**
   *
   * **NOTE:**
   * only use in route file
   * @internal
   */
  businessOnboardingInfoStep = "/onboarding/business-info/:step",
  businessOnboardingInfoProfile = "/onboarding/business-info/profile",
  businessOnboardingInfoContact = "/onboarding/business-info/contact",
  businessOnboardingInfoAddress = "/onboarding/business-info/address",
  businessOnboardingInfoVerify = "/onboarding/business-info/verify",
  /**
   * **NOTE:**
   * only use in route file
   * @internal
   */
  businessRegistrationStep = "/onboarding/registration/:step",
  businessRegistration = "/onboarding/registration",
  businessRegistrationInfo = "/onboarding/registration/info",
  businessRegistrationVerify = "/onboarding/registration/verify",
  /**
   * **NOTE:**
   * only use in route file
   * @internal
   */
  businessOnboardingPeopleStep = "/onboarding/people/:step",
  businessOnboardingPeople = "/onboarding/people",
  businessOnboardingPeopleProfile = "/onboarding/people/profile",
  businessOnboardingPeopleIdentity = "/onboarding/people/identity",
  businessOnboardingPeopleAddress = "/onboarding/people/address",
  businessOnboardingPeopleVerify = "/onboarding/people/verify",
  businessOnboardingPeopleOwnerShipStructure = "/onboarding/people/ownership-structure",
  businessOnboardingAccount = "/onboarding/account",
  businessOnboardingSummary = "/onboarding/summary",

  // dashboard
  app = "/app",
  dashboard = "/app/dashboard",
  transactions = "/app/transactions",
  transactionsPayment = "/app/transactions/payment",
  transactionsPaymentDetails = "/app/transactions/payment/:id",
  transactionsRefunds = "/app/transactions/refunds",
  transactionsRefundsDetails = "/app/transactions/refunds/:id",
  transactionsChargeBack = "/app/transactions/chargeback",
  transactionsChargeBackDetails = "/app/transactions/chargeback/:id",
  customers = "/app/customers",
  customer = "/app/customers/:id",
  transfers = "/app/transfers",
  transfersRemittance = "/app/transfers/remittance",
  transfersRemittanceDetails = "/app/transfers/remittance/:id",
  transfersInvoices = "/app/transfers/invoices",
  transfersInvoicesCreate = "/app/transfers/invoices/create",
  transfersInvoicesDetails = "/app/transfers/invoices/:id",
  transfersPaymentLinks = "/app/transfers/payment-links",
  transfersPaymentLinkDetails = "/app/transfers/payment-links/:id",
  recipients = '/app/transfers/recipients',
  subAccounts = "/app/subAccounts",
  storefronts = "/app/storefronts",
  manageStorefronts = "/app/storefronts/manage",
  storefrontProducts = "/app/storefronts/:storeId/products",
  storefrontProductDetails = "/app/storefronts/:storeId/products/:productId",
  storefrontOrders = "/app/storefronts/orders",
  storefrontOrder = "/app/storefronts/orders/:orderId",
  /**
 * **NOTE:**
 * only use in route file
 * @internal
 */
  settingsBase = "/app/settings/:section",
  settings = "/app/settings",
  settingsProfileSetup = "/app/settings/profile-setup",
  // audit log
  auditLog = "/app/audit-logs",
  analytics = "/app/analytics",
}
